import React, { useState } from 'react';

const SelectedOptionCard = ({ item, onRemove, onCountChange, productDetailData }) => {
  const [count, setCount] = useState(1);

  const handleDecrement = () => {
    if (count > 1) {
      setCount(count - 1);
      onCountChange(item, count - 1);
    }
  };

  const handleIncrement = () => {
    if (count >= item?.max_buy_count && !item?.unlimited) {
      return;
    }

    setCount(count + 1);
    onCountChange(item, count + 1);
  };

  return (
    <div className={'selected-card'}>
      <div className='selected-card-top-wrapper'>
        <div className='selected-card-top-title-group'>
          <p className={'selected-card-title'}>{item.item_name}</p>
        </div>
        <div className='selected-card-top-button-group'>
          <button
            type={'button'}
            className={'button-default close-button'}
            aria-label={'delete'}
            onClick={() => {
              onRemove(item);
            }}
          >
            <i className={'icon icon-close-gray'} />
          </button>
        </div>
      </div>
      <div className='selected-card-bottom-wrapper'>
        <div className='selected-card-bottom-count-group'>
          <button type={'button'} className={'button-default count-button'} onClick={handleDecrement}>
            -
          </button>
          <span className={'count-info'}>{count}</span>
          <button type={'button'} className={'button-default count-button'} onClick={handleIncrement}>
            +
          </button>
        </div>
        <div className='selected-card-bottom-price-group'>
          <p className={'price-info'}>
            {(item.item_price * count).toLocaleString()}
            &nbsp;{productDetailData?.currency}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectedOptionCard;
